export const DATA_ANALYST_SOURCES = [
  { id: 'banks_fdic_gov', label: 'FDIC Bank Data' },
  { id: 'bea_gov', label: 'U.S. Bureau of Economic Analysis' },
  { id: 'bls_gov', label: 'U.S. Bureau of Labor Statistics' },
  { id: 'census_gov', label: 'U.S. Census Bureau' },
  { id: 'climate_noaa_gov', label: 'NOAA Climate Data' },
  { id: 'cms_gov', label: 'Centers for Medicare & Medicaid Services' },
  { id: 'eia_gov', label: 'U.S. Energy Information Administration' },
  { id: 'finnhub', label: 'Finnhub market/financial data' },
  { id: 'fiscaldata_treasury_gov', label: 'U.S. Treasury Fiscal Data' },
  { id: 'fmp', label: 'Financial Modeling Prep' },
  { id: 'fred', label: 'FRED (St. Louis Fed)' },
  { id: 'hmda_cfpb_gov', label: 'HMDA (CFPB)' },
  { id: 'quickstats_nass_usda_gov', label: 'USDA NASS QuickStats' },
];

export const DATA_ANALYST_SOURCE_IDS = DATA_ANALYST_SOURCES.map((s) => s.id);
